/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

jQuery(document).ready(function($) {

    // function to check and show the DHL link
    function showDHLDrawer() {
        var $drawer = $('.dhl-drawer-custom');
        if ($drawer.length) { // element exists
            $.getJSON('https://ipapi.co/json/', function(location) {
                console.log('Visitor location:', location); // debug
                if(location.country === 'DE' || location.country_code === 'DE') {
                    $drawer.show();
                } else {
                    $drawer.hide();
                }
            }).fail(function(err){
                console.error('Geo lookup failed', err);
                $drawer.hide(); // fallback
            });
        } else {
            // retry after a short delay if drawer not yet in DOM
            setTimeout(showDHLDrawer, 200);
        }
    }

    // initial call
    showDHLDrawer();

});




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
